import { UserRepo } from "../domain/UserRepo";
import { User } from "../domain/User";

export interface LoadUsersScreenData {
  users: User[];
  ui_loading: boolean;
}

export class LoadUsersQuery {
  constructor(
    private userRepo: UserRepo,
    private screenData: LoadUsersScreenData
  ) {}

  async execute(): Promise<void> {
    this.screenData.ui_loading = true;
    try {
      const users = await this.userRepo.find_all();
      this.screenData.users = users;
    } finally {
      this.screenData.ui_loading = false;
    }
  }
}
